import { render, staticRenderFns } from "./EditDocumentTemplate.vue?vue&type=template&id=6a1843a8&scoped=true&"
import script from "./EditDocumentTemplate.vue?vue&type=script&lang=js&"
export * from "./EditDocumentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditDocumentTemplate.vue?vue&type=style&index=0&id=6a1843a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1843a8",
  null
  
)

export default component.exports